(function () {
  function initFaqContactForm(form) {
    if (!form || form.dataset.bdFaqContactFormInit === 'true') return;
    form.dataset.bdFaqContactFormInit = 'true';
    form.setAttribute('novalidate', 'novalidate');

    var fields = form.querySelectorAll('[data-bd-faq-field]');

    function clearErrors() {
      fields.forEach(function (field) {
        field.classList.remove('bd-faq-contact-form__field--error');
      });
    }

    function setFieldError(fieldName) {
      var field = form.querySelector('[data-bd-faq-field="' + fieldName + '"]');
      if (field) field.classList.add('bd-faq-contact-form__field--error');
    }

    function validateField(input) {
      var field = input.closest('[data-bd-faq-field]');
      if (!field) return true;

      var isRequired = input.hasAttribute('required');
      var value = (input.value || '').trim();

      if (!isRequired) {
        field.classList.remove('bd-faq-contact-form__field--error');
        return true;
      }

      if (input.type === 'email') {
        var validEmail = value !== '' && input.checkValidity();
        field.classList.toggle('bd-faq-contact-form__field--error', !validEmail);
        return validEmail;
      }

      var valid = value !== '';
      field.classList.toggle('bd-faq-contact-form__field--error', !valid);
      return valid;
    }

    fields.forEach(function (field) {
      var input = field.querySelector('input, select, textarea');
      if (!input) return;

      if (input.tagName === 'SELECT') {
        function syncSelectPlaceholder() {
          input.classList.toggle('is-placeholder', !input.value);
        }
        syncSelectPlaceholder();
        input.addEventListener('change', syncSelectPlaceholder);
      }

      input.addEventListener('input', function () {
        if (field.classList.contains('bd-faq-contact-form__field--error')) {
          validateField(input);
        }
      });

      input.addEventListener('blur', function () {
        if (input.hasAttribute('required')) validateField(input);
      });
    });

    form.addEventListener('submit', function (event) {
      clearErrors();
      var isValid = true;

      fields.forEach(function (field) {
        var input = field.querySelector('input, select, textarea');
        if (!input || !input.hasAttribute('required')) return;
        if (!validateField(input)) isValid = false;
      });

      if (!isValid) {
        event.preventDefault();
        var firstError = form.querySelector('.bd-faq-contact-form__field--error input, .bd-faq-contact-form__field--error select, .bd-faq-contact-form__field--error textarea');
        if (firstError) firstError.focus();
      }
    });

    if (form.dataset.hasErrors === 'true') {
      ['first_name', 'last_name', 'email', 'category', 'message'].forEach(setFieldError);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bd-faq-contact-form]').forEach(initFaqContactForm);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var forms = event.target.querySelectorAll('[data-bd-faq-contact-form]');
    forms.forEach(initFaqContactForm);
  });
})();
